import { Box, Button, Dialog, DialogTitle, Typography } from '@mui/material';
import { memo, ReactElement, useCallback } from 'react';

export interface LanguageDefinition {
  displayText: string;
  languageCode: string;
  icon?: string;
}

export interface LanguageSelectionDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

const AVAILABLE_LANGUAGES: LanguageDefinition[] = [
  {
    displayText: 'Deutsch',
    languageCode: 'de',
    icon: '🇩🇪',
  },
  //   {
  //     displayText: 'English',
  //     languageCode: 'en',
  //     icon: '🇺🇸 | 🇬🇧'
  //   },
  //   {
  //     displayText: 'Français',
  //     languageCode: 'fr',
  //     icon: '🇫🇷',
  //   },
  //   {
  //     displayText: 'Español',
  //     languageCode: 'es',
  //     icon: '🇪🇸',
  //   },
];

export const LanguageSelectionDialog = memo(function (props: LanguageSelectionDialogProps): ReactElement {
  const { isOpen, onClose } = props;

  const handleLanguageSelect = useCallback(
    (language: string) => {
      // TODO: Implement language selection logic
      onClose();
    },
    [onClose]
  );

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>
        <Typography variant='h6'>Sprachauswahl</Typography>
      </DialogTitle>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, padding: 2 }}>
        {AVAILABLE_LANGUAGES.map((language) => (
          <Button
            key={language.languageCode}
            color='primary'
            fullWidth
            onClick={() => handleLanguageSelect(language.languageCode)}
            sx={{
              justifyContent: 'flex-start',
              textTransform: 'none',
            }}
          >
            {language.icon && <Box sx={{ marginRight: 2 }}>{language.icon}</Box>}
            <Typography>{language.displayText}</Typography>
          </Button>
        ))}
      </Box>
    </Dialog>
  );
});
